import axios from 'axios';
import { API_ENDPOINTS } from '../../apiConfig';
export interface ProjectDTO {
    id?: string;
    tenantId: string;
    tenantName: string;
    contractId?: string;
    contractBidId?: string;
    licenseId?: string;
    createdBy?: string;
    updatedBy?: string;
    projectName?: string;
    description?: string;
    projectType?: string;
    status?: string;
    contractBidNo?: string;
    projectBidValue?: number;
    projectActualValue?: number;
    projectBidPercentage?: number;
    totalBudget?: number;
    licenseHolderName?: string;
    licenseNo?: string;
    givenStartDate?: string;
    givenEndDate?: string;
    actualStartDate?: string;
    actualEndDate?: string;
    extensionCount?: number;
    extensionDate?: string;
    terminationReason?: string;
    comment?: string;
  }
  
  export interface ProjectFilterDTO {
    status?: string;
    projectType?: string;
    contractBidId?: string;
    projectName?: string;
    description?: string;
    contractBidNo?: string;
    projectBidValue?: number;
    projectActualValue?: number;
    projectBidPercentage?: number;
    licenseHolderName?: string;
    givenStartDate?: string;
    givenEndDate?: string;
  }
  
  // types/KPIResponse.ts

export interface ProjectKpiResponse {
  projectCompletionPercentage: ProjectCompletionDto[];
  budgetUtilization: BudgetUtilizationDto[];
  totalEstimatedCost: EstimatedCostDto[];
  totalActualCost: ActualCostDto[];
  plannedVsActualTimeline: PlannedVsActualDto[];
  delayedTasks: AlertDto[];
  overBudgetTasks: AlertDto[];
  activeProjectsValueSummary: ProjectValueSummary;
  completedProjectsValueSummary: ProjectValueSummary;
}

export interface ProjectCompletionDto {
  projectId: string;
  projectName: string;
  completionPercentage: number;
}

export interface BudgetUtilizationDto {
  projectId: string;
  projectName: string;
  actualCost: number;
  totalBudget: number;
  budgetUtilizationPercentage: number;
}

export interface EstimatedCostDto {
  projectId: string;
  projectName: string;
  totalEstimatedCost: number;
}

export interface ActualCostDto {
  projectId: string;
  projectName: string;
  totalActualCost: number;
}

export interface PlannedVsActualDto {
  projectId: string;
  projectName: string;
  taskName: string;
  plannedStart: string; // ISO Date String
  plannedEnd: string;   // ISO Date String
  actualStart: string;  // ISO Date String
  actualEnd: string;    // ISO Date String
}

export interface AlertDto {
  projectId: string;
  projectName: string;
  taskName: string;
  alertType: string;
  givenEndDate: string; // ISO Date String
  actualEndDate: string; // ISO Date String
  estimatedCost: number;
  actualCost: number;
}

export interface ProjectValueSummary {
  totalProjectBidValue: number;
  totalProjectActualValue: number;
  totalProjectBudgetValue: number;
}

const API_BASE =  `${API_ENDPOINTS.project}/projects`;
const API_DASBOARD = `${API_ENDPOINTS.project}/kpi`;
//const API_DASBOARD = `${API_ENDPOINTS.platform}/contract-dashboard`;

 

export const ProjectApi = {
  create: (data: ProjectDTO) => axios.post(`${API_BASE}`, data),
  update: (id: string, data: ProjectDTO) => axios.put(`${API_BASE}/${id}`, data),
  delete: (id: string) => axios.delete(`${API_BASE}/${id}`),
  getById: (id: string) => axios.get(`${API_BASE}/${id}`),
  filter: (filter: ProjectFilterDTO) => axios.post(`${API_BASE}/filter`, filter),
// ✅ Added KPI Dashboard API
  getDashboardKPIs: () =>
  axios.get<ProjectKpiResponse>(`${API_DASBOARD}/projects`),
  
};